import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Disaster from "./Disaster";
import MissingPerson from "./MissingPerson";
import Advertisement from "./Advertisement";
import useEmergencyList from "hooks/useEmergencyList";
import { sponserService } from "services/sponsor.service";
import useSponserRequest from "hooks/useSponserRequest";

const Emergenytabs = (id) => {

  const [activeTab, setActiveTab] = useState("Disaster");

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  const handleClick = (event) => {
    event.stopPropagation();
  };
  const [dataLength, setDataLength] = useState({
    // skip: 0,
    limit: 10
  })
  const payload = {
    type: activeTab,
    limit: dataLength.limit
  }


  const [data, setData] = useState()
  const { emergencyData } = useEmergencyList(payload);
  const [emergencies, setEmergencies] = useState([]);

  useEffect(() => {
    setEmergencies(emergencyData)
  }, [emergencyData])

  const handleViewMore = () => {
    const data = dataLength.limit;
    setDataLength({
      ...data,
      limit: dataLength.limit + 10
    })
  }

  return (
    <div onClick={handleClick}>
      <Tabs
        activeKey={activeTab}
        className="emergecy-tabs"
        onSelect={handleTabSelect}
      >
        <Tab eventKey="Disaster" title="Disaster">
          <div>
            <Disaster activeTab={activeTab} emergencyData={emergencies} setEmergencies={setEmergencies} handleViewMore={handleViewMore} dataLength={dataLength} setDataLength={setDataLength} />
          </div>
        </Tab>
        <Tab eventKey="Missing" title="Missing person">
          <div>
            <MissingPerson activeTab={activeTab} emergencyData={emergencies} setEmergencies={setEmergencies} handleViewMore={handleViewMore} dataLength={dataLength} setDataLength={setDataLength} />
          </div>
        </Tab>
        <Tab eventKey="tab3" title="Advertisement">
          <div>
            <Advertisement activeTab={activeTab} handleViewMore={handleViewMore} id={id} dataLength={dataLength} setDataLength={setDataLength} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default Emergenytabs;
